import React, { lazy } from 'react';
import * as Icon from '@ant-design/icons';
import { ProtectedRoute } from '@components';

const FeatureRequirementPage = lazy(() => import('./page'));

export default {
  path: 'featureRequirement',
  element: <ProtectedRoute adminOnly title="功能需求单" component={<FeatureRequirementPage />} />,
  options: {
    title: '功能需求单',
    adminOnly: true,
    key: 'menu-featureRequirement',
    icon: <Icon.FileTextOutlined />,
    link: '/featureRequirement',
  },
};
